import React from "react";
import { Grid, useMediaQuery } from "@material-ui/core";
import { createUseStyles } from "react-jss";
import { useTranslation } from "react-i18next";
import { AssetClass } from "types/AssetClass";
import ReportDatePicker from "./ReportDatePicker";
import YieldHistory from "./AssetClassComponents/YieldHistory";
import AllocationHistory from "./AssetClassComponents/AllocationHistory";
import YieldList from "./AssetClassComponents/YieldList";
import Distributions from "./AssetClassComponents/Distributions";
import SummaryList from "./AssetClassComponents/SummaryList";
import YieldPerTimespan from "./AssetClassComponents/YieldPerTimespan";
import AssetClassDistributionList from "./AssetClassComponents/AssetClassDistributionList";
import KeyValues from "./KeyValues";
import { getKeyValuesData } from "utility/keyValues";
import { useSelector } from "react-redux";
import { RootState } from "redux/rootReducer";

interface Props {
  assetClass: AssetClass;
  title: string;
}

const useStyles = createUseStyles({
  container: {
    padding: "1em 0",
  },
});

const PageContainer = (props: Props) => {
  const { title, assetClass } = props;

  const classes = useStyles();

  const matchesMediaQuery = useMediaQuery("(min-width: 960px)");

  const summaryData = useSelector((state: RootState) => state.summary ?? []);

  const keyValuesData = getKeyValuesData(summaryData, assetClass);

  const { t } = useTranslation();

  return (
    <Grid container justifyContent="center">
      <Grid item container md={10} sm={12} justifyContent="space-between">
        {matchesMediaQuery ? (
          <Grid item xs={7} style={{ color: "#003366" }}>
            <h1>{t(title)}</h1>
          </Grid>
        ) : (
          <></>
        )}
        <Grid
          item
          container
          md={3}
          sm={12}
          alignContent="center"
          justifyContent={matchesMediaQuery ? "center" : "flex-start"}
        >
          <KeyValues
            marketValue={keyValuesData?.MarkkinaArvo}
            pageName={t(title)}
          />
        </Grid>
        <Grid
          container
          item
          md={2}
          sm={12}
          alignContent="center"
          justifyContent="flex-start"
        >
          <ReportDatePicker />
        </Grid>
      </Grid>
      <Grid
        className={classes.container}
        container
        item
        md={10}
        sm={12}
        flexDirection={matchesMediaQuery ? "row" : "column"}
      >
        <YieldHistory assetClass={assetClass} />
        <AllocationHistory assetClass={assetClass} />
      </Grid>
      <Grid
        container
        item
        md={10}
        sm={12}
        justifyContent="flex-start"
        style={{ paddingTop: 0 }}
      >
        <h3 style={{ color: "#444443", margin: 0 }}>{t("profit")}</h3>
      </Grid>
      <Grid
        className={classes.container}
        container
        item
        md={10}
        sm={12}
        style={{
          maxWidth: matchesMediaQuery ? "100%" : "calc(100% + 32px)",
          width: matchesMediaQuery ? "100%" : "calc(100% + 32px)",
        }}
      >
        <YieldList assetClass={assetClass} />
        <YieldPerTimespan assetClass={assetClass} />
      </Grid>
      <Grid container item md={10} sm={12} justifyContent="flex-start">
        <h3 style={{ color: "#444443", margin: 0 }}>{t("current")}</h3>
      </Grid>
      <Grid
        className={classes.container}
        container
        item
        md={10}
        sm={12}
        flexDirection={matchesMediaQuery ? "row" : "column"}
      >
        <Distributions assetClass={assetClass} />
      </Grid>
      <Grid
        container
        item
        md={10}
        sm={12}
        justifyContent="flex-start"
        style={{ paddingTop: 0 }}
      >
        <h3 style={{ color: "#444443", margin: 0 }}>{t("profit")}</h3>
      </Grid>
      <Grid
        className={classes.container}
        container
        item
        md={10}
        sm={12}
        style={{
          maxWidth: matchesMediaQuery ? "100%" : "calc(100% + 32px)",
          width: matchesMediaQuery ? "100%" : "calc(100% + 32px)",
        }}
      >
        <SummaryList assetClass={assetClass} />
        <AssetClassDistributionList assetClass={assetClass} />
      </Grid>
    </Grid>
  );
};

export default React.memo(PageContainer);
